// Barre d'en-tête des formulaires publics : logo, événement · dates, mention « Formulaire sécurisé ».
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Lock } from 'lucide-react';
import wiloutLogo from '../../images/wilout-logo-full.svg';

const PublicFormHeader = ({ projectName, datesLabel, maxWidth = 1360 }) => (
  <Box component="header" sx={{ flex: '0 0 auto', bgcolor: '#fff', borderBottom: '1px solid #dde3e8' }}>
    <Stack direction="row" alignItems="center" spacing={1.75} sx={{ maxWidth, mx: 'auto', px: 3, height: 56 }}>
      <img src={wiloutLogo} alt="Wilout" style={{ height: 18 }} />
      {(projectName || datesLabel) && (
        <>
          <Box sx={{ width: '1px', height: 20, bgcolor: '#dde3e8' }} />
          <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: '#5e646a' }}>
            {[projectName, datesLabel].filter(Boolean).join(' · ')}
          </Typography>
        </>
      )}
      <Box sx={{ flex: '1 1 auto' }} />
      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ fontSize: 12, color: '#5e646a', whiteSpace: 'nowrap' }}>
        <Lock size={11} />
        <span>Formulaire sécurisé</span>
      </Stack>
    </Stack>
  </Box>
);

export default PublicFormHeader;
